import {
  Component,
  Inject,
  inject,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NZ_DRAWER_DATA, NzDrawerRef } from 'ng-zorro-antd/drawer';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Subject, takeUntil } from 'rxjs';
import { VenueViewModel } from '../../models-views/venue.view.model';
import { AppCommon } from '../../providers/app-common';
import { QuickAddService } from '../../services/quick-add.service';

@Component({
  selector: 'app-venue-drawer',
  standalone: false,
  templateUrl: './venue-drawer.component.html',
  styleUrl: './venue-drawer.component.scss',
})
export class VenueDrawerComponent implements OnInit, OnDestroy {
  // data: any = inject(NZ_DRAWER_DATA);
  @Input() someInput!: string;
  form: FormGroup;
  loading = false;
  loadingMsg = 'Saving venue...';
  loggedInUser: any;
  venueData: any;
  venueTypeList: any[] = [];
  vendorList: any[] = [];
  countryList: any[] = [];
  stateList: any[] = [];
  cityList: any[] = [];
  destroy$ = new Subject();
  stateClearTimeOut: any;
  cityClearTimeOut: any;
  starValue = 0;
  preferanceArr = [
    {
      id: 1,
      name: 'Preferred',
    },
    {
      id: 2,
      name: 'Blacklisted',
    },
    {
      id: 3,
      name: 'N/A',
    },
  ];
  venueId: any = '';

  constructor(
    private drawerRef: NzDrawerRef,
    private fb: FormBuilder,
    private message: NzMessageService,
    private vn: VenueViewModel,
    private quickAddService: QuickAddService,
    @Inject(NZ_DRAWER_DATA) public data: any
  ) {
    this.loggedInUser = AppCommon.getloggedInObject().user;
    this.initForm();

    if (this.data?.venue) {
      // this.venueData = this.data.venue;
      this.updateForm(this.data.venue);
    }

    // this.vn.cityList
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe(
    //     (d) => (this.cityList = Array.isArray(d?.results) ? d.results : [])
    //   );

    this.vn.cityList.pipe(takeUntil(this.destroy$)).subscribe((d) => {
      this.cityList = Array.isArray(d?.results) ? d.results : [];

      const cityId = this.form.get('city')?.value;

      if (cityId) {
        // If the current cityId exists in the new cityList, re-set the value
        const exists = this.cityList.some((c) => c.id === cityId);
        if (exists) {
          this.form.get('city')?.setValue(cityId);
        }
      }
    });

    this.vn.venueTypeList.pipe(takeUntil(this.destroy$)).subscribe((d) => {
      this.venueTypeList = Array.isArray(d?.results) ? d.results : [];
    });
    this.vn.vendorList.pipe(takeUntil(this.destroy$)).subscribe((d) => {
      this.vendorList = Array.isArray(d?.results) ? d.results : [];
    });
    this.vn.getVenueTypeList();
    this.vn.getVendorList();
  }

  ngOnInit(): void {
    this.starValue = this.form.get('star_rating').value / 2;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  onStarChange(value: number) {
    this.form.get('star_rating').setValue(value * 2);
  }

  initForm() {
    this.form = this.fb.group({
      venue_name: ['', [Validators.required, Validators.minLength(3)]],
      venue_type: [null, Validators.required],
      brand: [null, Validators.required],
      star_rating: [
        null,
        [Validators.required, Validators.min(1), Validators.max(10)],
      ],
      country: [null],
      state: [null],
      city: [null, Validators.required],
      preference: [null],
      address: ['', Validators.required],
      neighborhood: [''],
      website: [
        '',
        [Validators.pattern(/^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[^\s]*)?$/)],
      ],
      about: [''],
    });
  }

  updateForm(data: any) {
    this.form.patchValue({
      venue_name: data?.name,
      venue_type: data?.venue_type,
      brand: data?.brand,
      star_rating: data?.star_rating / 2,
      country: data?.country_id,
      state: data?.state_id,
      city: data?.location_details?.id,
      address: data?.address,
      neighborhood: data?.neighborhood,
      preference: data?.preference,
      website: data?.website,
      about: data?.about,
      venueId: data?.id,
    });
    this.venueId = data?.id;
    this.onSearchCity(data?.location_details?.name);
  }

  onSearchCity(e: any) {
    clearTimeout(this.cityClearTimeOut);
    this.cityClearTimeOut = setTimeout(() => {
      if (e.length > 0) {
        this.vn.getCityListById(1, 500, undefined, e);
      }
    }, 400);
  }

  markAllControlsAsTouched(control: any) {
    if (control instanceof FormGroup) {
      Object.keys(control.controls).forEach((key) => {
        this.markAllControlsAsTouched(control.get(key));
      });
    } else {
      control.markAsTouched();
      control.markAsDirty();
    }
  }


  onSubmit() {
    if (this.form.valid) {
      let d = this.form.value;

      if (
        d.website &&
        !d.website.startsWith('http://') &&
        !d.website.startsWith('https://')
      ) {
        d.website = 'https://' + d.website;
      }

      d.star_rating = d.star_rating * 2;

      const payload: any = {
        name: d.venue_name, // Corrected to 'name' to match payload creation
        star_rating: d.star_rating,
        address: d.address,
        website: d.website,
        neighborhood: d.neighborhood,
        created_by: this.loggedInUser.id,
        brand: d.brand,
        venue_type: d.venue_type,
        city: d.city,
        preference: d.preference,
        about: d.about,
      };

      // Assign modified_by if it exists
      if (d.modified_by) {
        payload.modified_by = d.modified_by;
      }

      this.loading = true;
      this.loadingMsg = this.data?.venue
        ? 'Updating venue...'
        : 'Creating venue...';

      if (this.venueId) {
        payload.id = this.venueId;
        payload.modified_by = this.loggedInUser.id; // Set modified_by for update
        this.vn.updateVenue(this.venueId, payload); // Pass venueId and payload
        this.handleModelClose(); // Close the modal after a successful update
      } else {
        this.vn.createVenue(
          payload,
          () => this.handleModelClose(),
          () => (this.loading = false)
        );
      }
    } else {
      this.message.error('Please fill all required fields correctly');
      this.markAllControlsAsTouched(this.form);
    }
  }

  handleModelClose(): void {
    // Venue list refresh now handled in VenuesComponent
    const resultData = { confirmed: true };
    this.drawerRef.close(resultData);
    this.quickAddService.refreshData.next(true);
    this.loading = false;
  }
}
